import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "cart-gift-card-price-item" }
const _hoisted_2 = { class: "cart-gift-card-price-item__product-name-and-number" }
const _hoisted_3 = { class: "cart-gift-card-price-item__product-name" }
const _hoisted_4 = {
  key: 0,
  class: "cart-gift-card-price-item__details-spacer"
}
const _hoisted_5 = { class: "cart-gift-card-price-item__article-number" }
const _hoisted_6 = { class: "cart-gift-card-price-item__quantity-and-price" }
const _hoisted_7 = { class: "cart-gift-card-price-item__quantity" }
const _hoisted_8 = { class: "cart-gift-card-price-item__price" }
const _hoisted_9 = { class: "cart-gift-card-price-item__fee-quantity" }
const _hoisted_10 = { class: "cart-gift-card-price-item__fee-price" }

import { computed } from 'vue';
import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*@__PURE__*/_defineComponent({
  __name: 'CartGiftCardPriceItem',
  props: {
  item: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { websiteText } = useWebsiteTexts();
const { formatPrice } = useContext();
const giftCardFees = computed(() => {
  return props.item.giftCardFees?.map(f => {
    if (f.ignoreQuantity) return f;

    const pricePerItemString = `(${formatPrice(f.value)}/${websiteText('productdetailspage_printpieceabbreviated').value})`;

    return {
      ...f,
      priceString: pricePerItemString,
    };
  }) || [];
});

const unitPrice = computed(() => {
  if (!props.item.originalPrice) return props.item.currentPrice;
  return props.item.currentPrice < props.item.originalPrice
    ? props.item.currentPrice
    : props.item.originalPrice;
});

const itemTotalPrice = computed(() => {
  return props.item.totalPrice;
});

const quantityText = computed(() => {
  return `${props.item.quantity} ${websiteText('productdetailspage_printpieceabbreviated').value}`;
});

const pricePerItemText = computed(() => {
  return `(${formatPrice(unitPrice.value)}/${websiteText('productdetailspage_printpieceabbreviated').value})`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(websiteText)('giftcard__giftcard').value) + " - " + _toDisplayString(__props.item.variantName) + " " + _toDisplayString(__props.item.giftCardName), 1),
      (__props.item.articleNumber)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.item.articleNumber), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(quantityText.value) + " " + _toDisplayString(pricePerItemText.value), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(formatPrice)(itemTotalPrice.value)), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(giftCardFees.value, (fee, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `${fee.text}${fee.totalRow}${idx}`,
        class: "cart-gift-card-price-item__fee"
      }, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(fee.text) + " " + _toDisplayString(fee.priceString), 1),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(formatPrice)(fee.totalRow)), 1)
      ]))
    }), 128))
  ]))
}
}

})